import dsBridge from 'dsbridge'

export const jsBridge = function () {
  const args = arguments
  // eslint-disable-next-line
    if (args.length > 2) throw new Error('Parameter can\'t be multiple, you should use an Object.')
  return new Promise(function (resolve, reject) {
    dsBridge.call(args[0], args[1] || '{}', function (res) {
      if (typeof res === 'string') return resolve(JSON.parse(res))
      if (typeof res === 'object') {
        if (res.code && typeof res.code === 'string') res.code = res.code.toUpperCase() 
        return resolve(res)
      }

      /* eslint-disable */
            reject(new Error('Type of res is not allowed'))
        })
    }).then(res=>res,e=>e)
}

export const naBridge = function (...args) {
    dsBridge.register(...args)
}
export const hasNativeMethod = function (method) {
    return dsBridge.hasNativeMethod(method)
}